import { useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { savePageState, resetCurrentPage } from "../store/state/pageSlice";
import { useLocation } from "react-router-dom";

export function usePageState(key, defaultValue) {
  const location = useLocation();
  const dispatch = useDispatch();
  const saved = useSelector((s) => s.pages.states[location.pathname]?.[key]);
  const state = saved !== undefined ? saved : defaultValue;

  // Setter: dispatch merged state to redux
  const setState = useCallback(
    (newValue) => {
      dispatch(
        savePageState({
          path: location.pathname,
          pageState: { [key]: newValue },
        })
      );
    },
    [dispatch, location.pathname, key]
  );

  // Handle reload reset
useEffect(() => {
  const handleReload = (event) => {
    console.log("Real browser refresh detected!");
    dispatch(resetCurrentPage(location.pathname));
  };

  // pageshow with persisted property works for F5 / back-forward cache reload
  window.addEventListener("pageshow", (event) => {
    if (event.persisted) {
      handleReload();
    }
  });

  // beforeunload triggers on F5 / Ctrl+R / browser refresh
  window.addEventListener("beforeunload", handleReload);

  return () => {
    window.removeEventListener("beforeunload", handleReload);
    window.removeEventListener("pageshow", handleReload);
  };
}, [dispatch, location.pathname]);



  return [state, setState];
}
